import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import Layout from './components/layout';
import Content from './components/content';
import Router from './components/router';
import Config from './config/config';
import CustomFirebase from './helpers/custom-firebase';
import Session from './components/session';
import KeyAdder from './components/key/add';
import { LoadingBlock } from './components/loading';
import CacheBuster from './CacheBuster';

import 'antd/dist/antd.css';
import './lana.scss';

const App = () => {
  CustomFirebase.init(Config.firebase);

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) { return null; }
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          <BrowserRouter>
            <Session>
              <Suspense fallback={<LoadingBlock />}>
                <Layout>
                  <KeyAdder />
                  <Content style={{ padding: '20px 20px', display: 'block' }}>
                    <Router />
                  </Content>
                </Layout>
              </Suspense>
            </Session>
          </BrowserRouter>
        );
      }}
    </CacheBuster>
  );
};

export default App;
